import DashboardIcon from "@mui/icons-material/Dashboard";
import HubIcon from "@mui/icons-material/Hub";
import PersonIcon from "@mui/icons-material/Person";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BadgeIcon from "@mui/icons-material/Badge";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { GeneralRoute } from "../Models/routesModel";
import {
  LazyDashboard,
  LazyDoors,
  LazyDetailDoor,
  LazySettings,
  LazyLogs,
  LazyLicenseLogs,
  LazyUsers,
  LazyDetailUser,
  LazySupportUser,
  LazySupportUserDetail,
  LazyCustomerRequests,
  LazyPartner,
  LazyShipping,
  LazyDetailSensor,
  LazySensors,
  LazyAccountDeviceSubscription,
  LazyCameras,
  LazyDetailCamera,
  LazyHubs,
  LazyDetailHub,
  LazyGateway,
  LazyDetailAppliances,
} from "./lazyComponents";
import { EScopesType } from "../Models/auth";
import AccessControlIcon from "../../../assets/icons/AccessControlIcon";
import CameraIcon from "../../../assets/icons/DomCameraIcon";
import SensorIcon from "../../../assets/icons/SensorIcon";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import RouterIcon from "@mui/icons-material/Router";
//////////////////////////////////////
export const pathRoute = {
  Dashboard: "/",
  Doors: { Index: "/doors", Details: "/doors/details", Video: "/doors/video" },
  Cameras: { Index: "/cameras", Details: "/cameras/details", Video: "/cameras/video" },
  Hubs: { Index: "/hubs", Details: "/hubs/details" },
  Gateway: { Index: "/gateway", Details: "/gateway/appliancesdetails" },

  Users: {
    Index: "/users",
    Details: "/users/details",
  },
  Groups: {
    Index: "/groups",
    Details: "/groups/details",
  },
  Schedules: {
    Index: "/schedules",
    Details: "/schedules/details",
  },
  Profile: {
    Index: "/profile",
  },
  Settings: {
    Index: "/settings",
  },
  Zones: {
    Index: "/zones",
    Details: "/zones/details",
  },
  SignIn: {
    Index: "/signin",
    ForgotPassword: "/signin/forgotpassword",
  },
  Action: "/action",
  Logs: { Index: "/logs" },
  LicenseLogs: { Index: "/license-logs" },
  SupportUser: {
    Index: "/support-user",
    Details: "/support-user/details",
  },
  CustomerRequests: {
    Index: "/customer-requests",
  },
  Partner: {
    Index: "/partner",
  },
  Shipping: {
    Index: "/shipping",
  },
  Visitors: {
    Index: "/visitors",
    Details: "/visitors/details",
    Schedules: "/visitors/schedules",
    SchedulesDetails: "/visitors/schedules/details",
  },
  Sensor: {
    Index: "/sensors",
    Details: "/sensors/details",
  },
  AccountDeviceSubscription: {
    Index: "/accountDeviceSubscription",
  },
};
/////////////////////////////////////
export const generalPortalRoutes: GeneralRoute[] = [
  {
    id: "Route_Dashboard",
    path: pathRoute.Dashboard,
    exact: true,
    sideBarNavIcon: DashboardIcon,
    textLangSidebarNav: "Dashboard",
    mainContentComponent: <LazyDashboard />,
    authorization: [EScopesType.supportportalaccess_r],
    skipSideBarMenu: false,
  },
  {
    id: "Route_Users",
    path: pathRoute.Users.Index,
    exact: true,
    skipSideBarMenu: false,
    textLangSidebarNav: "Users",
    startSidebarSection: true,
    sideBarNavIcon: PersonIcon,
    mainContentComponent: <LazyUsers />,
    needAccountAssigned: true,
    authorization: [EScopesType.operator_w],
  },
  {
    id: "Route_DetailUser",
    path: pathRoute.Users.Details,
    exact: true,
    skipSideBarMenu: true,
    mainContentComponent: <LazyDetailUser />,
    needAccountAssigned: true,
    authorization: [EScopesType.operator_r],
  },
  {
    id: "Route_Doors",
    path: pathRoute.Doors.Index,
    exact: true,
    skipSideBarMenu: false,
    textLangSidebarNav: "Doors",
    sideBarNavIcon: AccessControlIcon,
    mainContentComponent: <LazyDoors />,
    needAccountAssigned: true,
    authorization: [EScopesType.operator_r],
  },
  {
    id: "Route_DetailDoor",
    path: pathRoute.Doors.Details,
    exact: true,
    skipSideBarMenu: true,
    mainContentComponent: <LazyDetailDoor />,
    needAccountAssigned: true,
    authorization: [EScopesType.operator_r],
  },
  {
    id: "Route_Cameras",
    path: pathRoute.Cameras.Index,
    exact: true,
    skipSideBarMenu: false,
    textLangSidebarNav: "Cameras",
    sideBarNavIcon: CameraIcon,
    mainContentComponent: <LazyCameras />,
    needAccountAssigned: true,
    authorization: [EScopesType.operator_r],
  },
  {
    id: "Route_DetailCamera",
    path: pathRoute.Cameras.Details,
    exact: true,
    skipSideBarMenu: true,
    mainContentComponent: <LazyDetailCamera />,
    needAccountAssigned: true,
    authorization: [EScopesType.operator_r],
  },
  {
    id: "Route_Hubs",
    path: pathRoute.Hubs.Index,
    exact: true,
    skipSideBarMenu: false,
    textLangSidebarNav: "Hubs",
    sideBarNavIcon: HubIcon,
    mainContentComponent: <LazyHubs />,
    needAccountAssigned: true,
    authorization: [EScopesType.operator_r],
  },
  {
    id: "Route_DetailHub",
    path: pathRoute.Hubs.Details,
    exact: true,
    skipSideBarMenu: true,
    mainContentComponent: <LazyDetailHub />,
    needAccountAssigned: true,
    authorization: [EScopesType.operator_r],
  },
  {
    id: "Route_Gateway",
    path: pathRoute.Gateway.Index,
    exact: true,
    skipSideBarMenu: false,
    textLangSidebarNav: "Gateway",
    sideBarNavIcon: RouterIcon,
    mainContentComponent: <LazyGateway />,
    needAccountAssigned: true,
    authorization: [EScopesType.operator_r],
  },
  {
    id: "Route_DetailGateway",
    path: pathRoute.Gateway.Details,
    exact: true,
    skipSideBarMenu: true,
    mainContentComponent: <LazyDetailAppliances />,
    needAccountAssigned: true,
    authorization: [],
  },

  {
    id: "Route_Sensors",
    path: pathRoute.Sensor.Index,
    exact: true,
    skipSideBarMenu: false,
    textLangSidebarNav: "Sensors",
    sideBarNavIcon: SensorIcon,
    mainContentComponent: <LazySensors />,
    needAccountAssigned: true,
    authorization: [EScopesType.operator_r], //operator
  },
  {
    id: "Route_DetailSensor",
    path: pathRoute.Sensor.Details,
    exact: true,
    skipSideBarMenu: true,
    mainContentComponent: <LazyDetailSensor />,
    needAccountAssigned: true,
    authorization: [EScopesType.operator_r],
  },
  {
    id: "Route_AccountDeviceSubscription",
    path: pathRoute.AccountDeviceSubscription.Index,
    exact: true,
    skipSideBarMenu: false,
    textLangSidebarNav: "Device Subscription",
    sideBarNavIcon: WarehouseIcon,
    mainContentComponent: <LazyAccountDeviceSubscription />,
    endSidebarSection: true,
    needAccountAssigned: true,
    authorization: [EScopesType.supportportalaccess_r], //
  },
  {
    id: "Route_Settings",
    path: pathRoute.Settings.Index,
    exact: true,
    mainContentComponent: <LazySettings />,
    authorization: [EScopesType.supportportalaccess_r], // Await for confirm
    skipSideBarMenu: true,
  },
  {
    id: "Route_Logs",
    path: pathRoute.Logs.Index,
    exact: true,
    skipSideBarMenu: false,
    sideBarNavIcon: AssignmentIcon,
    textLangSidebarNav: "Logs",
    addToSideBarMenuInMobile: false,
    mainContentComponent: <LazyLogs />,
    authorization: [EScopesType.support_r],
  },
  {
    id: "Route_License_Logs",
    path: pathRoute.LicenseLogs.Index,
    exact: true,
    skipSideBarMenu: false,
    sideBarNavIcon: AssignmentIcon,
    textLangSidebarNav: "License Logs",
    addToSideBarMenuInMobile: false,
    mainContentComponent: <LazyLicenseLogs />,
    authorization: [EScopesType.support_r],
  },
  {
    id: "Route_SupportUsers",
    path: pathRoute.SupportUser.Index,
    exact: true,
    skipSideBarMenu: false,
    sideBarNavIcon: BadgeIcon,
    textLangSidebarNav: "Support Users",
    addToSideBarMenuInMobile: false,
    mainContentComponent: <LazySupportUser />,
    authorization: [EScopesType.support_w],
  },
  {
    id: "Route_SupportUserDetail",
    path: pathRoute.SupportUser.Details,
    exact: true,
    skipSideBarMenu: true,
    mainContentComponent: <LazySupportUserDetail />,
    authorization: [EScopesType.support_w],
  },
  {
    id: "Route_CustomerRequests",
    path: pathRoute.CustomerRequests.Index,
    exact: true,
    skipSideBarMenu: false,
    sideBarNavIcon: AssignmentLateIcon,
    textLangSidebarNav: "Requests",
    addToSideBarMenuInMobile: false,
    mainContentComponent: <LazyCustomerRequests />,
    authorization: [EScopesType.operator_r],
  },
  {
    id: "Route_Partner",
    path: pathRoute.Partner.Index,
    exact: true,
    skipSideBarMenu: false,
    sideBarNavIcon: GroupWorkIcon,
    textLangSidebarNav: "Partner",
    addToSideBarMenuInMobile: false,
    mainContentComponent: <LazyPartner />,
    authorization: [EScopesType.support_w],
  },
];
